import { Button } from "@mui/material";
import React from "react";
function GrafoButton(props){
    return <Button className="grafoButton"  sx={{ boxShadow: 0 }} variant="contained" {...props}>{props.children}</Button>
}

export default GrafoButton;